<div class="code-textbox" data-id="codeMirror">
  <ngx-codemirror
    [(ngModel)]="modelData"
    (ngModelChange)="onModelChange()"
    [options]="{
      lineNumbers: true,
      theme: 'material',
      mode: fieldConfig.codeMode,
      indentUnit: 2,
      readOnly: !editMode,
    }"></ngx-codemirror>
</div>
